import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {CardTable} from 'views/module';
import NextStepsSection from 'views/scenes/dashboard/dashboard_scene/Sections/NextStepsSection';

import Card from './Card';

const List = (props) => {
  const {data, isLoading} = props;

  return (
    <CardTable
      data={data}
      card={Card}
      isLoading={isLoading}
      getItemId={(item) => item.caregiverRn}
      emptyState={<NextStepsSection />}
    />
  );
};
List.propTypes = {
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(List));
